export type ChatRoomType = 0 | 1 | 2 | 3;
export type PresenceStatus = 0 | 1 | 2 | 3;

export interface ChatConversation {
  id: string;
  name: string;
  roomType: ChatRoomType;
  roomTypeLabel: string;
  description?: string | null;
  avatarUrl?: string | null;
  projectId?: string | null;
  lastMessageAt?: string | null;
  lastMessagePreview?: string | null;
  memberCount: number;
  unreadCount: number;
  isPinned: boolean;
  isMuted: boolean;
  isArchived: boolean;
  isAdmin: boolean;
  isOwner: boolean;
  peerUserId?: string | null;
  peerName?: string | null;
  peerPresence?: PresenceStatus | null;
  peerLastSeenAt?: string | null;
  peerAvatarUrl?: string | null;
}

export interface ChatMember {
  userId: string;
  displayName: string;
  email?: string | null;
  avatarUrl?: string | null;
  isOwner: boolean;
  isAdmin: boolean;
  joinedAt: string;
  presence: PresenceStatus;
  lastSeenAt?: string | null;
}

export interface ChatAttachment {
  id: string;
  fileName: string;
  originalFileName: string;
  contentType: string;
  sizeBytes: number;
  url?: string | null;
  thumbnailUrl?: string | null;
  isImage: boolean;
}

export interface ChatReaction {
  emoji: string;
  count: number;
  reactedByMe: boolean;
}

export interface ChatMessage {
  id: string;
  roomId: string;
  senderId: string;
  senderName: string;
  senderAvatarUrl?: string | null;
  content: string;
  messageType: string;
  replyToMessageId?: string | null;
  replyPreview?: string | null;
  forwardedFromMessageId?: string | null;
  isEdited: boolean;
  editedAt?: string | null;
  isPinned: boolean;
  deletedForEveryone: boolean;
  createdAt: string;
  attachments: ChatAttachment[];
  reactions: ChatReaction[];
}

export interface ChatSearchHit {
  messageId: string;
  roomId: string;
  roomName: string;
  snippet: string;
  senderName: string;
  createdAt: string;
}

export interface UserPresence {
  userId: string;
  displayName: string;
  status: PresenceStatus;
  statusLabel: string;
  statusMessage?: string | null;
  lastSeenAt: string;
}

export interface AttachmentInput {
  fileName: string;
  originalFileName: string;
  contentType: string;
  sizeBytes: number;
  storagePath: string;
  url?: string | null;
  thumbnailUrl?: string | null;
  storedFileId?: string | null;
}

export interface ChatUserOption {
  userId: string;
  displayName: string;
  email: string;
  avatarUrl?: string | null;
  employeeId?: string | null;
}

export const PRESENCE_ONLINE = 1;
export const ROOM_DIRECT = 0;
export const ROOM_GROUP = 1;
